import { defineStore } from 'pinia'
import { User } from '../types/userTypes'

export interface UserState {
  user: User | null
  token: string | null
  tokenExpirationTime: number | null
  isLoggedIn: boolean
  lastActivity: number | null
  inactivityTimeout: number | null
  password: string | null
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    token: localStorage.getItem('token'),
    tokenExpirationTime: localStorage.getItem('tokenExpirationTime')
      ? Number(localStorage.getItem('tokenExpirationTime'))
      : null,
    isLoggedIn: localStorage.getItem('isLoggedIn') === 'true',
    lastActivity: null,
    inactivityTimeout: null,
    password: null,
  }),
  actions: {
    setUser(user: User | null) {
      this.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    setToken(token: string) {
      this.token = token
      this.tokenExpirationTime = Date.now() + 25 * 60 * 1000 // 25 minutes, same as public token
      localStorage.setItem('token', token)
      localStorage.setItem(
        'tokenExpirationTime',
        this.tokenExpirationTime.toString()
      )
    },
    setPassword(password: string) {
      this.password = password
      // Note: We don't store the password in localStorage for security reasons
    },
    setLoggedIn(status: boolean) {
      this.isLoggedIn = status
      localStorage.setItem('isLoggedIn', status.toString())
      if (status) {
        this.resetInactivityTimeout()
      }
    },
    logout() {
      this.user = null
      this.token = null
      this.tokenExpirationTime = null
      this.isLoggedIn = false
      this.password = null
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      localStorage.removeItem('tokenExpirationTime')
      localStorage.removeItem('isLoggedIn')
      this.clearInactivityTimeout()
    },
    resetInactivityTimeout() {
      this.lastActivity = Date.now()
      localStorage.setItem('lastActivity', this.lastActivity.toString())
      this.clearInactivityTimeout()
      this.setInactivityTimeout()
    },
    setInactivityTimeout() {
      const timeout = 30 * 60 * 1000 // 30 minutes
      this.inactivityTimeout = window.setTimeout(() => {
        const currentTime = Date.now()
        const lastActivity = parseInt(
          localStorage.getItem('lastActivity') || '0',
          10
        )
        if (currentTime - lastActivity >= timeout) {
          this.logout()
        }
      }, timeout)
    },
    clearInactivityTimeout() {
      if (this.inactivityTimeout) {
        clearTimeout(this.inactivityTimeout)
        this.inactivityTimeout = null
      }
    },
  },
})
